import React, { useContext } from "react";

// Material UI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Global state
import { StateContext } from "../../AppStateContext.js";

const AddClassFormPropertiesHeader = () => {
  // To consume global state
  const state = useContext(StateContext);
  return (
    <>
      <div className="__schemaAddClassPropertiesTable">
        <h3
          className={
            state.theme === "dark"
              ? "__addClassFormTextColorDark"
              : "__addClassFormTextColorLight"
          }
        >
          Properties{" "}
          <Tooltip
            placement="right-start"
            title=" Properties define what kind of data values you can add to a data object in Weaviate. In the schema, you define at least the name of the property and its dataType."
          >
            <HelpIcon
              style={{
                fontSize: "15px",
                color: state.theme === "dark" ? "#848484" : "#5e5e5e",
                cursor: "pointer",
                marginLeft: "6px",
              }}
            />
          </Tooltip>
        </h3>
      </div>
      <div
        className={
          state.theme === "dark"
            ? "__addClassPropertyTableHeaderDark __addClassPropertyTableHeader"
            : "__addClassPropertyTableHeader __addClassPropertyTableHeaderLight"
        }
      >
        <h4>Name</h4>
        <h4 style={{ marginLeft: "-60px" }}>Description</h4>
        <h4>Data Type</h4>
      </div>
    </>
  );
};

export default AddClassFormPropertiesHeader;
